import { useLocation, useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewGroup from 'modules/posts/components/Groups/New'

export default function NewGroupPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { navigation } = useNavigation()

  const isDashboardUrl = location.pathname.includes(navigation.dashboard.fullPath())

  const handleClose = () => {
    if (!isDashboardUrl) {
      navigate(-1)
    } else {
      navigate(navigation.dashboard.fullPath())
    }
  }

  const handleSuccessClose = (groupId: number) => {
    if (!isDashboardUrl) {
      navigate(navigation.communities.id.fullPath({ id: groupId.toString() }))
    } else {
      navigate(navigation.dashboard.fullPath())
    }
  }

  return <NewGroup onClose={handleClose} onSuccessClose={handleSuccessClose} />
}
